import { makeStyles } from 'tss-react/mui';

const name = 'ChainPageLoader';

export const useChainPageLoaderStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
  },
}));
